import { createFileRoute } from "@tanstack/react-router"
import { validateReviewsSearch } from "@/features/operations/operations-search"
import { ReviewsPage } from "@/features/operations/reviews-page"
export const Route = createFileRoute("/_authenticated/reviews")({
    validateSearch: validateReviewsSearch,
    component: ReviewsPage,
})
